import { render } from "./SidenavGroup.vue?vue&type=template&id=07365a72"
import script from "./SidenavGroup.vue?vue&type=script&lang=js"
export * from "./SidenavGroup.vue?vue&type=script&lang=js"

import "./SidenavGroup.vue?vue&type=style&index=0&id=07365a72&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__